import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, delay, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class DepartOrgValidatorService implements AsyncValidator {
  deptTakenError: string | null = null;
  private baseUrl: string = environment.baseUrlAuth;



  constructor( private http: HttpClient ) { }
  validate(control: AbstractControl<any, any>): Observable<ValidationErrors | null> {
    const departValue: string = control.value;

    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.get<any[]>(`${this.baseUrl}/api/auth/deparatmentos?nombredp=${departValue}`, { headers })
      .pipe(
        map(resp => {
          // console.log(resp)
          if (resp.length === 1 && resp[0].name === departValue) {
            this.deptTakenError = `El nombre: "${departValue}" ya esta creado`;
            return {
              deptTaken: true
            };
          } else {
            this.deptTakenError = null
            return null;
          }
        })).pipe(
          delay(100)
      )
  }



}
